import { MDTApi } from './mdtapi.js';

export const getFeatureConfiguration = (territoryId, countryId, appid) => {
    const params = {
        app: appid,
        ...(!!territoryId && { territoryId }),
        ...(!!countryId && { countryId }),
    };
    
    return MDTApi.call('api.forms.featuresConfigured', {
        method: 'GET',
        params,
    });
}

export const getDownloadHideConfig = () => {
    return MDTApi.call('api.forms.downloadHide', {
        method: 'GET',
        setBuidSiteIdInHeader: true,
        headers: {
            Authorization: '',
        },
    });
}

export const getOpenIdConfiguration = () => {
    return MDTApi.call('api.login.config', {
        method: 'GET'
    });
}

export const getDefaultCustomer = () => {
    return MDTApi.call('api.login.defaultCustomer', {
        method: 'GET'
    });
}


export const getDefaultContract = () => {
    return MDTApi.call('api.login.defaultContract', {
        method: 'GET'
    });
}

export const getUserPermissions = (customerid) => {

    return MDTApi.call('api.login.userPermissions', {
        method: 'GET',
    }, {
        customerId: customerid
    });
}

export const getUserInfoCall = () => {
    return MDTApi.call('api.login.userinfo', {
        method: 'GET'
    }, {}, !window.showloaderFirstTime);
}

export const getUserDetails = () => {
    return MDTApi.call('api.profile.profile', {
        method: 'GET'
    }, {}, false);
}

export const getCustomerInfoCall = () => {
    let fetchCutomerApi = 'api.customer.v3.searchCustomers';
    const isCustomerSource = window.octopusFeatures && window.octopusFeatures.isCustomerSource === 'false' ? false : true;
    const includeInactive = window.octopusFeatures && window.octopusFeatures.includeInactive === 'true' ? true : false;

    return MDTApi.call(fetchCutomerApi, {
        method: 'GET',
        data: {
            searchText: '',
            pageSize: 10
        }
    }, {"isCustomerSource": isCustomerSource, 'includeInactive': includeInactive});
}

export const getCountryList = () => {
    return MDTApi.call('api.common.countries', {
        method: 'GET',
    });
};

export const fetchAPINotificationPreferencesList = () => {
    return MDTApi.call('api.notifications.notificationPreferencesList', {
        method: 'GET',
    });
};

